// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1xSuS","inner":"Footer_inner__vCgqN","nextIcon":"Footer_nextIcon__36TQX","innerLeft":"Footer_innerLeft__1MV4H"};